import {useState, useEffect} from 'react';
import { Grid, Button, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import ImageGalleryHolder from 'core/components/image-gallery/ImageGalaryHolder';
import { attachAssetToProductAPI } from 'api/OmsOrdermgmtWebServices';
import { addProductassetObj, updateProductassetObj,setProductassetList } from 'store/slice/PharmaSlice';
import { setProductSelectImageModal } from 'store/slice/PharmaSlice';
import { setMultiSelection, setSelectedAssetIdList } from 'store/slice/ImageGallerySlice';


export default function SelectImageActionImpl(){
    const dispatch = useDispatch();
    const {productObj} = useSelector((state) => state.pharmaslice.productDashboard);
    const {productassetList} = useSelector((state) => state.pharmaslice);
    const {selectedImagePath, selectedImage, imageType, selectedAssetIdList, assetList} = useSelector((state) => state.imagegalleryslice);
    
    useEffect(() => {
        //dispatch(setMultiSelection(true)); // Disable multi-selection for this action
    }, []); 

    const attachAssetToProductAPISuccess = (responseObj) => {
        //dispatch(setProductassetList(responseObj.productassetInfoList.list));
        dispatch(setProductSelectImageModal(false));
    }
    const attachAssetList = () => {
        dispatch(setProductSelectImageModal(false));
        // if (!selectedAssetIdList) return;
        
        
        // const assetIds = selectedAssetIdList.split(',').map(id => id.trim()).filter(id => id);
        // console.log("assetIds:", assetIds);
        // assetIds.forEach(assetId => {
        //     // Find the asset object by id from assetList
        //     const assetObj = assetList.find(asset => String(asset.id) === assetId);
        //     // Only attach if not already in productassetList
        //     const alreadyLinked = productassetList.some(pa => String(pa.assetid) === assetId);
        //     if (assetObj && !alreadyLinked) {
        //         attachAsset(assetObj);
        //     }
        // });
    }
    const attachAsset = (assetObj) => {
        attachAssetToProductAPI({
            "assetId": assetObj.id,
            "title":assetObj.name,
            "name":assetObj.name,
            "assetPath": assetObj.path,
            "productId": productObj.id,
            "assetType": imageType
        }, attachAssetToProductAPISuccess
        , (error) => {
            alert(error);
        })
    }
    
    
    return (
        <>
       <ImageGalleryHolder label="Link Image to Product" clickToAction={()=>attachAssetList()}/>
        </>
    )
}